import React from "react";

import * as Styled from "./styles";

interface TabPanelProps {
  id: string;
  value: number;
  index: number;
  isAssistant?: boolean;
  isVisible?: boolean;
  unmountOnExit?: boolean;
}

const TabPanel: React.FC<TabPanelProps> = (
  { id, children, value, index, isAssistant, isVisible, unmountOnExit, ...rest }
) => {

  const showChildren = unmountOnExit ? value === index : (value >= index || !isAssistant) && isVisible;

  return (
    <Styled.Container
      role="tabpanel"
      hidden={value !== index}
      id={`${id}-${index}`}
      aria-labelledby={`${id}-${index}`}
      {...rest}
    >
      {showChildren && children}
    </Styled.Container>
  );
};

TabPanel.defaultProps = {
  isAssistant: false,
  isVisible: true,
  unmountOnExit: false
};

export default TabPanel;
